//audioUtils.js
import {serverUrl} from './ConfigHolder'
import { fetchToken } from './auth';
import axios from 'axios';


export const playAudioUrl = async (url, onFailure = () => {}) => {
    const audioElement = new Audio(url);

    audioElement.onerror = (error) => {
        console.error("Error playing audio URL (maybe expired):", error);
        onFailure();
    };

    audioElement.play().catch((error) => {
        console.error("Playback failed:", error);
        onFailure();
    });
};


export const fetchAudioUrl = async (filename) => {
    if (filename) {
        try {
        const token = fetchToken(); // Synchronous call
        if (!token) {
            throw new Error('No token found');
        }
        console.log('fetching url:', filename)
        const response = await axios.get(`${serverUrl}/get-audio-url/${filename}`, {
                headers: {
                    Authorization: `Bearer ${token}`,  // Include the JWT token in the Authorization header
                },
            });
        return response.data.url;  // Assuming the URL is returned as `url` in the response data
        } catch (error) {
            console.error("Error fetching audio URL:", error);
            // Handle errors here, e.g., show an error message to the user
            return null;
        }
    } else { 
        return null;
    }
};